export const ARTICLES_PART3 = [
  {
    slug: "palto-s-norkovoy-otdelkoy",
    title: "Пальто с норковой отделкой: как выбрать и с чем носить",
    seoTitle: "Пальто с норковой отделкой — как выбрать, цены, фото | Angiolini",
    description:
      "Пальто с норковой отделкой — главный компромисс между шубой и классическим пальто. Как выбрать модель, на что смотреть при покупке, с чем носить и где купить в Алматы.",
    date: "2026-07-02",
    readTime: "6 мин",
    tag: "Пальто",
    image: "/media/cover-e.jpg",
    sections: [
      {
        h: "Почему пальто с мехом норки — выбор номер один",
        ps: [
          "Пальто с норковой отделкой сочетает строгость классического кроя и роскошь натурального меха. Оно теплее обычного шерстяного пальто, выглядит статуснее и при этом остаётся легче и универсальнее шубы — его уместно носить и в офис, и на вечерний выход.",
          "Итальянские дома делают отделку из цельных пластин норки и соболя: воротник, планка, манжеты или капюшон. Такой мех не только украшает силуэт, но и защищает от ветра самые уязвимые зоны.",
        ],
      },
      {
        h: "На что смотреть при выборе",
        ps: [
          "Ткань: лучшие пальто шьют из кашемира, шерсти альпаки или смесовых полотен с кашемиром — они держат форму и не скатываются. Проведите рукой: поверхность должна быть плотной и шелковистой.",
          "Мех: отделка из норки или соболя должна быть густой, блестящей и равномерной по цвету. Пластины — подобраны без «ступенек», ворс мгновенно расправляется после сжатия.",
          "Крой: обратите внимание на посадку плеча и длину. Свободные силуэты и модели с поясом — самые актуальные; они позволяют носить пальто и с платьем, и с плотным трикотажем.",
        ],
      },
      {
        h: "Где купить пальто с норковой отделкой в Алматы",
        ps: [
          "В коллекции Angiolini — итальянские пальто с отделкой из норки и соболя: от строгих однотонных моделей до кейпов со съёмным мехом. Каждая вещь проходит контроль качества и финальную подгонку в нашем ателье в Алматы.",
          "Откройте каталог в приложении Angiolini: актуальные модели, цены и размеры всегда под рукой, а за регистрацию начисляются приветственные бонусы.",
        ],
      },
    ],
  },
  {
    slug: "kashemirovoe-palto-s-mekhom",
    title: "Кашемировое пальто с мехом: тренд, который не выходит из моды",
    seoTitle: "Кашемировое пальто с мехом норки и соболя — гид | Angiolini",
    description:
      "Кашемировое пальто с меховой отделкой: почему это самая желанная верхняя одежда сезона, как отличить настоящий кашемир, модные фасоны и цвета 2026 года.",
    date: "2026-07-05",
    readTime: "5 мин",
    tag: "Кашемир",
    image: "/media/cover-d.jpg",
    sections: [
      {
        h: "Кашемир + мех: формула идеальной зимы",
        ps: [
          "Кашемир даёт лёгкость и благородную фактуру, мех — тепло и статус. Вместе они создают вещь, которая согревает в мороз и при этом не выглядит громоздкой: кашемировое пальто с меховой планкой весит вдвое меньше шубы.",
          "В коллекциях итальянских брендов чаще всего встречается отделка из соболя и норки в тон полотна: шоколад на капучино, графит на сером, тёмный орех на верблюжьем. Такие сочетания выглядят дорого и не выходят из моды.",
        ],
      },
      {
        h: "Фасоны и оттенки сезона",
        ps: [
          "Главные силуэты 2026 года — свободный оверсайз с рукавом кимоно, укороченные жакеты с меховой планкой по борту и классика с поясом. Меховая отделка смещается с воротника на центральную планку — этот приём визуально вытягивает силуэт.",
          "Палитра — природная: капучино, орех, графит, топлёное молоко. Универсальный выбор — пальто в оттенке кэмел с мехом на два тона темнее.",
        ],
      },
      {
        h: "Как проверить качество",
        ps: [
          "Сожмите полотно на несколько секунд — настоящий кашемир почти не мнётся. Посмотрите швы: у премиальных марок они тонкие и ровные, подкладка — шёлковая или вискозная, без перекосов.",
          "Кашемировые пальто с мехом от итальянских брендов уже в каталоге Angiolini — с примеркой в шоуруме в Алматы и подгонкой по фигуре. Регистрируйтесь в приложении и выбирайте свою модель.",
        ],
      },
    ],
  },
  {
    slug: "pukhoviki-premium-klassa",
    title: "Женские пуховики премиум-класса: чем они отличаются от масс-маркета",
    seoTitle: "Пуховики премиум-класса женские — отличия и бренды | Angiolini",
    description:
      "Чем премиальный пуховик отличается от обычного: наполнитель, ткань, фурнитура и посадка. Как выбрать тёплый пуховик на зиму и какие бренды заслуживают доверия.",
    date: "2026-07-08",
    readTime: "6 мин",
    tag: "Пуховики",
    image: "/media/cover-a.jpg",
    sections: [
      {
        h: "Что скрывается за словом «премиум»",
        ps: [
          "Премиальный пуховик — это не просто цена. Это наполнитель из отборного гусиного пуха с fill power от 700, мембранные ткани, которые держат ветер и влагу, фурнитура YKK и продуманный крой, в котором тепло не значит бесформенно.",
          "Массмаркет экономит на всём: смесовый наполнитель сбивается комками уже через сезон, швы пропускают холод, а силуэт теряет форму после первой химчистки. Премиальный пуховик служит 7–10 лет, сохраняя вид новой вещи.",
        ],
      },
      {
        h: "Пять признаков качественного пуховика",
        ps: [
          "Первое — маркировка наполнителя: ищите обозначение down (пух), а не feather (перо). Второе — равномерность: сожмите секцию, пух должен быстро восстановиться и не мигрировать по отсекам.",
          "Третье — швы: у премиальных марок они проклеены или закрыты планками, чтобы не выпускать тепло. Четвёртое — капюшон и манжеты: плотная посадка без зазоров. Пятое — подкладка и молнии: гладкие, прочные, с фирменной гравировкой.",
        ],
      },
      {
        h: "Где искать премиальные пуховики в Алматы",
        ps: [
          "Angiolini привозит в Казахстан пуховики премиум-класса европейских брендов — MARCO DEL FORTE, Be Florence и Torriss: от лаконичных городских моделей до эффектных дизайнерских принтов.",
          "Все модели с ценами и размерами — в приложении Angiolini. Зарегистрируйтесь, получите приветственные бонусы и запишитесь на примерку в шоуруме в Нурлы Тау.",
        ],
      },
    ],
  },
  {
    slug: "italyanskie-pukhoviki-brendy",
    title: "Итальянские пуховики: гид по брендам MARCO DEL FORTE, Be Florence и Torriss",
    seoTitle: "Итальянские пуховики женские — бренды и обзор | Angiolini",
    description:
      "Обзор премиальных брендов верхней одежды: MARCO DEL FORTE, Be Florence и Torriss. Чем отличаются, какие модели выбрать и где купить итальянские пуховики в Алматы.",
    date: "2026-07-11",
    readTime: "7 мин",
    tag: "Бренды",
    image: "/media/cover-b.jpg",
    sections: [
      {
        h: "MARCO DEL FORTE: смелость миланской школы",
        ps: [
          "MARCO DEL FORTE — бренд для тех, кто не хочет растворяться в толпе. Фирменные дизайнерские принты, объёмные капюшоны с меховой отделкой, пояса, подчёркивающие талию, — каждый пуховик выглядит как вещь с подиума, оставаясь тёплым и практичным.",
          "Визитная карточка марки — лимитированные принтованные коллекции: логомания, акварельные разводы, графика. Такие модели быстро расходятся и редко доезжают до распродаж.",
        ],
      },
      {
        h: "Be Florence: тихая роскошь Флоренции",
        ps: [
          "Be Florence исповедует философию quiet luxury: чистые линии, благородная палитра, безупречные материалы. Пальто и пуховики марки создаются для повседневной жизни — офиса, прогулок, путешествий — и делают любой образ собраннее.",
          "В коллекциях много моделей с отделкой из натурального меха и комбинированных вещей: стёганые вставки на кашемировой основе, съёмные меховые детали.",
        ],
      },
      {
        h: "Torriss: инженерия тепла",
        ps: [
          "Torriss делает ставку на функциональность: мембранные ткани, проклеенные швы, пух высокой упругости и продуманные детали — ветрозащитные планки, регулируемые капюшоны с мехом, скрытые карманы. Это пуховики для настоящей зимы, в том числе казахстанской.",
          "Все три бренда представлены в коллекции Angiolini в Алматы. Сравнить модели, цены и размеры удобнее всего в приложении — новинки появляются там раньше, чем где-либо.",
        ],
      },
    ],
  },
  {
    slug: "marco-del-forte-pukhoviki",
    title: "MARCO DEL FORTE: пуховики, в которых Милан встречает зиму",
    seoTitle: "MARCO DEL FORTE — купить пуховик в Алматы | Angiolini",
    description:
      "Пуховики MARCO DEL FORTE: фирменные принты, меховые капюшоны и миланский крой. Обзор коллекции, знаковые модели и где купить MARCO DEL FORTE в Казахстане.",
    date: "2026-07-14",
    readTime: "5 мин",
    tag: "MARCO DEL FORTE",
    image: "/media/cover-b.jpg",
    sections: [
      {
        h: "Характер бренда",
        ps: [
          "MARCO DEL FORTE родился из простой идеи: зимняя одежда не обязана быть скучной. Дизайнеры марки переносят на технологичные ткани смелую графику и фирменную логоманию, а силуэты выверяют так, что даже объёмный пуховик стройнит.",
          "Каждая коллекция — ограниченный тираж. Модель, которая понравилась сегодня, через месяц можно уже не найти: бренд принципиально не повторяет удачные принты.",
        ],
      },
      {
        h: "Знаковые детали",
        ps: [
          "Объёмный капюшон с меховой отделкой, широкий пояс с фирменной пряжкой, двусторонние молнии и лаковые акценты — по этим деталям пуховик MARCO DEL FORTE узнаётся мгновенно.",
          "Внутри — гусиный пух высокой упругости и ветрозащитные планки: миланский шик рассчитан на настоящие морозы, а не только на фотосессии.",
        ],
      },
      {
        h: "Где примерить в Алматы",
        ps: [
          "Актуальная коллекция MARCO DEL FORTE уже в шоуруме Angiolini в Нурлы Тау и в каталоге приложения: фото, цены и наличие размеров обновляются ежедневно.",
          "Зарегистрируйтесь в приложении Angiolini — получите приветственные бонусы и первыми узнавайте о новых поставках бренда.",
        ],
      },
    ],
  },
];
